import { apiCall } from "./Interceptor";

const CATEGORY_ALL = "/category/getAll/public";

const getAllCategory = async (data) => {
    let url = CATEGORY_ALL;
    if (data) {
        url += `?type=${data}`;
    }
    const response = await apiCall.get(url);
    return response;
}

export default {
    getAllCategory,
};
